import { FC, ReactElement, useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { useTransition, animated, config } from '@react-spring/web'
import { IoFilterOutline } from 'react-icons/io5'

interface ScrollUpButtonProps {
  children?: React.ReactNode
  onHidden: (hidden: boolean) => void
}

const ScrollUpButton: FC<ScrollUpButtonProps> = ({
  children,
  onHidden,
}): ReactElement => {
  const mainRef = useRef<HTMLDivElement | null>(null)

  const mainIntersectionCallback = (entries: any) => {
    entries.forEach((entry: any) => {
      if (entry.isIntersecting) {
        // onHidden(false)
      } else {
        const boundingClientRect = entry.boundingClientRect
        const rootBounds = entry.rootBounds

        if (boundingClientRect.bottom < rootBounds.top) {
          onHidden(true) // When leaving the viewport from the top
        }
      }
    })
  }

  useEffect(() => {
    if (mainRef && mainRef.current) {
      const mainObserver = new IntersectionObserver(mainIntersectionCallback, {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px 0px 0px',
      })

      mainObserver.observe(mainRef.current)
    }
  }, [mainRef])

  return (
    <>
      <Container ref={mainRef}>{children}</Container>
    </>
  )
}

const Container = styled(animated.div)``

export default ScrollUpButton
